/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.date.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import "@/api";
import 'vux';
import DoctorItem from '@/components/DoctorItem';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { MUTATION_APPT_DETAIL } from '@/store/mutation_types';
export default {
  props: {
    imgSrc: String,
    docTechpost: String,
    docName: String,
    docSpecial: String,
    apptDates: {
      type: Array,
      "default": []
    },
    index: {
      type: Number
    }
  },
  data: function data() {
    return {};
  },
  components: {
    DoctorItem: DoctorItem
  },
  created: function created() {},
  mounted: function mounted() {},
  watch: {},
  methods: _objectSpread(_objectSpread({}, mapMutations({})), {}, {
    //选择排班
    schduleChoose: function schduleChoose(index, schduleIndex) {
      console.log(index, schduleIndex);
      this.$emit('schduleChoose', index, schduleIndex);
    },
    //查看更多
    goDoctorDetail: function goDoctorDetail(index) {
      this.$emit('goDoctorDetail', index); // this.isShowSeeMore = true;
      // this.currentIndex = index;
      // if (this.schedulDoctorModel === '2') {
      //     this.currentSchedule = this.doctors[index].apptDates.slice(3);
      // } 
    },
    dateToWeek: function dateToWeek(date) {
      date = new Date(date);
      var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      return week[date.getDay()];
    }
  })
};